// extracted by mini-css-extract-plugin
export default {"checkboxGroupLabel":"WjZm4xUneukh3pWji2yO"};